export default "__VITE_ASSET__902ad06e__"